export const links = {
  docs: {
    renterd: 'https://docs.sia.tech/renting/about-renting',
    hostd: 'https://docs.sia.tech/hosting/about-hosting-on-sia',
    walletd: 'https://docs.sia.tech/wallet/wallet-overview',
  },
  apiDocs: {
    renterd: 'https://api.sia.tech/renterd',
    hostd: 'https://api.sia.tech/hostd',
    walletd: 'https://api.sia.tech/walletd',
  },
  github: {
    renterd: 'https://github.com/SiaFoundation/renterd',
    hostd: 'https://github.com/SiaFoundation/hostd',
    walletd: 'https://github.com/SiaFoundation/walletd',
  },
}
